import { render } from "./Employee.vue?vue&type=template&id=1120bae4"
import script from "./Employee.vue?vue&type=script&lang=js"
export * from "./Employee.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PROJECT\\Mbf5_HCC\\XaTanHungHph\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__